import React from "react";
import styled from "styled-components";
import { AccentBar, Divider, SectionHeading } from "./SessionPageComponents";

const JOURNEY_STEPS = [
  {
    numeral: "I",
    title: "Submit your Plea",
    description:
      "Present your name and intent. Choose your words carefully. This is your first act of surrender — and your first impression to Me.",
  },
  {
    numeral: "II",
    title: "My Decision",
    description:
      "Your plea will be read in silence. I decide who is chosen and who fades. If chosen, you will receive the details about your Tribute and an invitation for a 20min audio call. If my terms are accepted, communications will move to Telegram.",
  },
  {
    numeral: "III",
    title: "The Initial Call",
    description:
      "During our call we will assess a bit more about each other, check if the connection we sense translates well into reality, and discuss minor logistics. You may bring any questions you might have. I will be curious to know more about who you are as a submissive.",
  },
  {
    numeral: "IV",
    title: "Your First Offering",
    description:
      "A partial Tribute locks in your date. The remainder follows closer to the day itself.",
  },
  {
    numeral: "V",
    title: "Your Initiation",
    description:
      "The day is finally here. Preparations were made. The trust that could be built, was built. And yet the adrenaline is high. As you move to greet Me, you leap into the unknown — your Rite of Passage. Time and space might feel different. And as you slowly fall into this bittersweet abyss, you will gradually — and gladly — surrender to Me.",
  },
  {
    numeral: "VI",
    title: "Your place in My Inner Circle",
    description: (
      <>
        Those who please Me, remain close. The communication remains open via
        Telegram. And if I'm impressed, you will receive an invitation to{" "}
        <a
          href="/the-descent"
          style={{
            textDecoration: "underline",
            textDecorationColor: "var(--color-emphasis)",
          }}
        >
          My Inner Circle
        </a>
        .
      </>
    ),
  },
];

export const SessionTributeSection = () => (
  <SectionWrapper>
    <TributeBlock>
      <SectionHeading>The Tribute</SectionHeading>
      <AccentBar />
      <TributeText>
        Tributes are always considered individually. As a point of reference,
        few fall beneath four figures when considering the full experience,
        including location.
        <br />
        Submissives inside{" "}
        <a
          href="/the-descent"
          style={{
            textDecoration: "underline",
            textDecorationColor: "var(--color-emphasis)",
          }}
        >
          My Inner Circle
        </a>{" "}
        have some privileges in that regard, in a case by case basis.
      </TributeText>
    </TributeBlock>

    <JourneyBlock>
      <SectionHeading>The Servant's Journey</SectionHeading>
      <AccentBar />

      <StepsList>
        {JOURNEY_STEPS.map((step, index) => (
          <React.Fragment key={step.numeral}>
            <Step>
              <StepNumeral>{step.numeral}</StepNumeral>
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Step>
            {index < JOURNEY_STEPS.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </StepsList>
    </JourneyBlock>
  </SectionWrapper>
);

/* ─── Layout ─── */

const SectionWrapper = styled.section`
  margin: 8rem 0;
  text-align: center;
`;

const TributeBlock = styled.div`
  margin-bottom: 9rem;
`;

const JourneyBlock = styled.div`
  margin-top: 6rem;
`;

/* ─── Content ─── */

const TributeText = styled.p`
  max-width: 690px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.8;
  color: var(--color-bone);
`;

const StepsList = styled.div`
  max-width: 690px;
  margin: 0 auto;
`;

const Step = styled.div``;

const StepNumeral = styled.span`
  display: block;
  font-size: 11px;
  letter-spacing: 0.15em;
  color: var(--color-bone);
  margin-top: 2rem;
  margin-bottom: 0.2rem;
`;

const StepTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
  font-size: larger;
  font-weight: 500;
`;

const StepDescription = styled.p`
  text-align: center;
  margin-top: 0;
  font-size: 16px;
`;
